export const EXPLANATION_ERROR = 'Must not be empty. Please enter a reason';

const FewerComparablesReasonValidator = {
  validate(fewerComparablesReason = {}) {
    const {declared, explanation} = fewerComparablesReason;
    let errors = {};

    if (declared !== true) {
      // No message — the unticked checkbox is outlined in red instead.
      errors.declared = true;
    }

    if (!explanation || !explanation.trim()) {
      errors.explanation = EXPLANATION_ERROR;
    }

    return errors;
  }
};

export default FewerComparablesReasonValidator;
